<div class="left-container">
    <div [hrblockMicroAppLoader]="ProductDetails" ></div>
</div> 
